import { FC, PropsWithChildren } from 'react';

import { Text } from '@hh.ru/magritte-ui';

import styles from './index.less';

interface Props {
    title: string;
    dataQaName?: string;
}

const Field: FC<Props & PropsWithChildren> = ({ title, children, dataQaName = 'field' }) => {
    return (
        <div className={styles.field}>
            <div className={styles.title} data-qa={`resume-serp__resume-item-${dataQaName}-title`}>
                <Text Element="span" typography="label-3-regular" style="secondary">
                    {title}
                </Text>
            </div>
            <div className={styles.content} data-qa={`resume-serp_resume-item-${dataQaName}-content`}>
                {children}
            </div>
        </div>
    );
};

export default Field;
